import Types from './Types';

export const getAllAnnouncementsRequest = (body) => ({
    type: Types.GET_ANNOUNCEMENTS_REQUEST,
    payload: body
});

export const getAllAnnouncementsSuccess = (data) => ({
    type: Types.GET_ANNOUNCEMENTS_SUCCESS,
    payload: data
});

export const getAllAnnouncementsFail = () => ({
    type: Types.GET_ANNOUNCEMENTS_FAIL
});

export const editAnnouncementRequest = (formData, action) => ({
    type: Types.EDIT_ANNOUNCEMENT_REQUEST,
    payload: formData,
    action: action
});

export const editAnnouncementSuccess = (data) => ({
    type: Types.EDIT_ANNOUNCEMENT_SUCCESS,
    payload: data
});

export const editAnnouncementFail = () => ({
    type: Types.EDIT_ANNOUNCEMENT_FAIL
});

//LOADING
export const addAnnouncementLoading = (isLoading) => ({
    type: Types.ADD_ANNOUNCEMENTS_LOADING,
    payload: isLoading
});

// Create Announcement
export const createAnnouncementRequest = (formData, action) => ({
    type: Types.CREATE_ANNOUNCEMENT_REQUEST,
    payload: formData,
    action: action
});

export const createAnnouncementSuccess = ({ data }) => ({
    type: Types.CREATE_ANNOUNCEMENT_SUCCESS,
    payload: {
        data
    }
});

export const createAnnouncementFail = () => ({
    type: Types.CREATE_ANNOUNCEMENT_FAIL
});

export const deleteAnnouncementRequest = (id) => ({
    type: Types.DELETE_ANNOUNCEMENT_REQUEST,
    payload: id
});

export const deleteAnnouncementSuccess = (id) => ({
    type: Types.DELETE_ANNOUNCEMENT_SUCCESS,
    payload: id
});

export const deleteAnnouncementFail = () => ({
    type: Types.DELETE_ANNOUNCEMENT_FAIL
});

export const activateAnnouncementRequest = (id) => ({
    type: Types.ACTIVATE_ANNOUNCEMENT_REQUEST,
    payload: id
});

export const activateAnnouncementSuccess = (data) => ({
    type: Types.ACTIVATE_ANNOUNCEMENT_SUCCESS,
    payload: data
});

export const activateAnnouncementFail = () => ({
    type: Types.ACTIVATE_ANNOUNCEMENT_FAIL
});

